module.exports = __webpack_public_path__ + "img/vehicle-test-020.91fb7d1d.png";